import { createSelector } from 'reselect';

export const getWorkoutProgramState = (state) => state.workoutProgram;

export const getSelectedWorkoutRange = createSelector(
  getWorkoutProgramState,
  ({ dateRange }) => dateRange
);

export const getSelectedWorkoutLocation = createSelector(
  getWorkoutProgramState,
  ({ location }) => location
);

export const getSelectedExercise = createSelector(
  getWorkoutProgramState,
  ({ selectedExercise }) => selectedExercise
);

export const getWorkoutProgramItems = createSelector(
  getWorkoutProgramState,
  ({ workoutProgram }) => workoutProgram
);
